/**
 * Local shim for `@eventbrite/feature-detection` (eb-ui) — the eds-share-box
 * source only used `HAS_WINDOW` + `getWindowObject`. SSR-guarded, no deps
 * (fleet precedent: cx-bot / listings-preview local shims).
 */
export const HAS_WINDOW = typeof window !== 'undefined';

export const getWindowObject = <K extends keyof Window>(
    name: K,
): Window[K] | undefined => (HAS_WINDOW ? window[name] : undefined);
